"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralRevokeFailException = void 0;
class ReferralRevokeFailException extends Error {
    constructor() {
        super("Revoking referral failed!");
        this.name = "ReferralRevokeFailException";
    }
}
exports.ReferralRevokeFailException = ReferralRevokeFailException;
